import React from "react";
import { text } from "protocol-setup/helpers/useLabelsAndHelpText";

export default function Text({ bundle }) {
  const t = text(bundle);

  if (typeof t === "string" && t.includes("\n")) {
    return (
      <>
        {t.split("\n").map((item) => (
          <p key={item}>{item}</p>
        ))}
      </>
    );
  }

  return <>{t}</>;
}
